<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
    <a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading"
      @change="onTableChange">
      <template #industry="{ text }">
        <dict-render :dict-obj="dictObjs['research_field']" :text="text"></dict-render>
      </template>
      <template #educationBackground="{ text }">
        <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
      </template>
      <template #salary="{ text }">
        <dict-render :dict-obj="dictObjs['salary']" :text="text"></dict-render>
      </template>
      <template #workExperience="{ text }">
        <dict-render :dict-obj="dictObjs['work_experience']" :text="text"></dict-render>
      </template>
      <template #action="{ record }">
        <a-popconfirm title="确认要邀请吗?" @confirm="onPass(record.id)">
          <a>邀请</a>
        </a-popconfirm>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { dictMixin, tableListMixin, formMixin } from "@/mixins";
import { enterpriseRrecruitmentInfo, personalRecommendation } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { dateFormat } from "@/config/variableConfig";
import { message } from "ant-design-vue";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "职位名称", dataIndex: "jobTitle", key: "jobTitle" },
  { title: '行业类型', dataIndex: "industry", key: "industry", slots: { customRender: "industry" } },
  { title: '学历', dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
  { title: '薪资', dataIndex: "salary", key: "salary", slots: { customRender: "salary" } },
  { title: '工作经验', dataIndex: "workExperience", key: "workExperience", slots: { customRender: "workExperience" } },
  { title: "招聘人数", dataIndex: "numberRecruits", key: "numberRecruits" },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin, formMixin],
  components: {
    DictRender
  },
  data() {
    return {
      form: {
        id: null,
        userId: null,
      },
      dateFormat,
      dictNames: 'research_field,education_background,salary,work_experience,hope_job',
      columns,
      queryParam: {},
      listUrl: '',
      listKeyField: "id",
    }
  },
  created() {
    this.getAction({
      url: enterpriseRrecruitmentInfo.noPageList
    }).then(res => {
      this.dataSource = res
    })
  },
  methods: {
    onPass(record) {
      console.log('111',record)
      this.postAction({
        url: personalRecommendation.isPass,
        params: { id: this.form.id, userId: this.form.userId, companyJobOpeningsId: record }
      }).then(() => {
        message.success('操作成功！')
        this.onCloseModal()
      })
    }
  }
}
</script>

<style scoped></style>
